export enum AvailChannel {
  Talk2VA = "Talk2VA",
  Cinnox = "Cinnox",
  Facebook = "Facebook",
  MetaWhatsapp = "MetaWhatsapp",
  Whatsapp = "Whatsapp",
}
